import { useEffect, useState } from "react";
import { Input, Modal, ModalHeader, ModalBody } from "reactstrap";
import { getTableStatusHistory } from "../../../utils/apiCalls";
import { C, tbl, reportingGlobalCSS } from "../../reporting/reportingStyles";
import { Badge, Loader } from "../../reporting/ReportingShared";

const statusBadge = (s) => {
  if (s === "available") return { color: C.green, bg: C.greenLight };
  if (s === "occupied") return { color: C.coral, bg: C.coralLight };
  if (s === "reserved") return { color: C.orange, bg: C.orangeLight };
  return { color: C.textMed, bg: C.borderLight };
};

const TableStatusHistoryModal = ({ isOpen, toggle, tableId, tableName }) => {
  const [history, setHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dateFilter, setDateFilter] = useState("");

  useEffect(() => {
    if (isOpen && tableId) {
      setHistory([]);
      fetchHistory();
    }
  }, [isOpen, tableId, dateFilter]);

  const fetchHistory = async () => {
    setIsLoading(true);
    const data = await getTableStatusHistory({ tableId, ...(dateFilter && { date: dateFilter }) });
    setHistory(data || []);
    setIsLoading(false);
  };

  return (
    <>
      <style>{reportingGlobalCSS}</style>
      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle} style={{ borderBottom: `1px solid ${C.borderLight}`, fontFamily: "'Inter', sans-serif" }}>
          <span style={{ fontWeight: 700, color: C.text }}>Status History {tableName ? `— ${tableName}` : ""}</span>
        </ModalHeader>
        <ModalBody className="rpt-wrap" style={{ padding: 20 }}>
          <div style={{ marginBottom: 16 }}>
            <Input
              type="date"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
              style={{ maxWidth: 200, borderRadius: 8, border: `1px solid ${C.border}`, fontSize: 14 }}
            />
          </div>

          {isLoading ? <Loader /> : history.length === 0 ? (
            <p style={{ textAlign: "center", padding: 24, color: C.textLight }}>No history found</p>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table style={tbl.table}>
                <thead>
                  <tr>
                    {["Previous", "New", "Source", "Reason", "Updated By", "Time"].map((h) => (
                      <th key={h} style={tbl.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {history.map((entry) => {
                    const prevSb = statusBadge(entry.previousStatus);
                    const newSb = statusBadge(entry.newStatus);
                    return (
                      <tr key={entry.id} className="rpt-row">
                        <td style={tbl.td}>{entry.previousStatus ? <Badge color={prevSb.color} bg={prevSb.bg}>{entry.previousStatus}</Badge> : "—"}</td>
                        <td style={tbl.td}><Badge color={newSb.color} bg={newSb.bg}>{entry.newStatus}</Badge></td>
                        <td style={tbl.td}><Badge color={C.blue} bg={C.blueLight}>{entry.source}</Badge></td>
                        <td style={{ ...tbl.td, color: C.textMed }}>{entry.reason || "—"}</td>
                        <td style={{ ...tbl.td, color: C.textMed }}>{entry.updatedBy || "—"}</td>
                        <td style={{ ...tbl.td, color: C.textLight, fontSize: 12, whiteSpace: "nowrap" }}>{entry.timestamp ? new Date(entry.timestamp).toLocaleString() : "—"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default TableStatusHistoryModal;
